import React, { useContext, useEffect, useState } from "react";
import SecondHeader from "../Header/SecondHeader";
import VehicleHead from "./VehiclesParts/VehicleHead";
import { popupcontext } from "../../context/Popupscontext";
import { Helmet } from "react-helmet";
import Loader from "../Helpers/Loader/Loader";
import { useDispatch } from "react-redux";
import { addVehicles } from "../../Redux/service/Vehicles/VehiclesSlice";
import { filtrationcontext } from "../../context/Filtercontext";
import { useGetAllCustomVehiclesQuery } from "../../Redux/service/Vehicles/CustomVehicles";
import { VehicleForm } from "./VehicleForm/VehicleForm";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import trans, { isRTL } from "../../utils";
import VehicleBulkUpload from "./VehicleBulkUpload/VehicleBulkUpload";
import AntdTable from "../antd/Table/Table";
import { formatDate } from "../../JsHelpers/DateFormat";
import { Tag } from "antd";
import Actions from "../antd/Table/Actions";
import Link from "../Helpers/Table/Table Actions/Link";
import Button from "../Helpers/Button/Button";
import VehicleUsers from "./VehiclesTableBody/VehicleUsers";
import usePermission from "../../hooks/usePermission";

export default function Vehicles() {
	const [activeViewId, setActiveViewId] = useState(null);

	const {
		handleShow,
		setEdited,
		deleteItem,
		setDeleteItem,
		reloadData,
		setReloadData,
	} = useContext(popupcontext);
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
		vehicleArchived,
	} = useContext(filtrationcontext);
	const { create, edit, delete: canDelete } = usePermission("FMSVEHICLES");

	let { pathname } = useLocation();
	let getShortPath = () => pathname.split("/").pop();
	let vehicleApi = getShortPath() === "vehicles";
	const [loading, setLoading] = useState(false);
	const [sort, setSort] = useState({
		by: "id",
		order: "desc",
	});
	const [currentPage, setCurrentPage] = useState(1);
	const [bulkUpload, setBulkUpload] = useState(false);
	const [filter, setFilter] = useState({
		deviceType: null,
	});
	const buildQueryString = (filterObj) => {
		const query = Object.entries(filterObj)
			.filter(
				([_, value]) => value !== null && value !== "" && value !== undefined,
			)
			.map(([key, value]) => `${key}=${value}`)
			.join("&");

		return query;
	};

	const queryString = buildQueryString(filter);
	const {
		data: vehiclesData,
		isLoading,
		isError,
		refetch,
		error,
	} = useGetAllCustomVehiclesQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
			queryParam: queryString,
		},
		{
			skip: !currentPage || !limit || !sort.by || !sort.order || !vehicleApi,
			refetchOnMountOrArgChange: true,
		},
	);
	const dispatch = useDispatch();

	useEffect(() => {
		return () => {
			SetSortFilter({ type: "id", value: null });
			setCurrentPage(1);
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		if (vehiclesData) {
			dispatch(addVehicles(vehiclesData.vehicles));
			if (vehiclesData.vehicles.length === 0 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
			}
		}
		setLoading(false);
	}, [vehiclesData, dispatch, currentPage, refetch]);

	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);

	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "vehicles") {
			refetch();
			if (vehiclesData?.vehicles.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			dispatch(addVehicles(vehiclesData?.vehicles));
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		dispatch,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		vehiclesData?.vehicles,
	]);
	useEffect(() => {
		refetch();
		setReloadData(false);
	}, [reloadData, refetch]);
	const handleSuccess = (newVehicle) => {
		if (vehiclesData) {
			const updatedVehicles = [newVehicle, ...vehiclesData.vehicles].slice(
				0,
				limit,
			);
			dispatch(addVehicles(updatedVehicles));
			setLoading(true);
			refetch();
		}
	};

	const handleEdit = (updatedVehicle) => {
		if (vehiclesData) {
			dispatch(
				addVehicles(
					vehiclesData.vehicles.map((vehicle) =>
						vehicle.id === updatedVehicle.id ? updatedVehicle : vehicle,
					),
				),
			);
			setEdited(true);
			refetch();
		}
	};
	if (isError)
		return toast.error(trans(error?.data?.message || "Please try again"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});

	const checkExpire = (licenseExpire) => {
		const expireTime = new Date(licenseExpire).getTime();
		if (!licenseExpire || expireTime === 0 || isNaN(expireTime)) return "N/A";

		const now = Date.now();
		const tenDays = 10 * 24 * 60 * 60 * 1000;
		const diff = expireTime - now;
		const daysRemaining = Math.ceil(diff / (1000 * 60 * 60 * 24));

		if (diff <= 0) return <Tag color="red">{trans("Expired")}</Tag>;
		if (diff <= tenDays)
			return (
				<Tag color="yellow">{`${daysRemaining} ${trans("days left")}`}</Tag>
			);
		return <Tag color="green">{trans("Valid")}</Tag>;
	};

	const getExpireStatusClass = (licenseExpire) => {
		const expireTime = new Date(licenseExpire).getTime();
		if (!licenseExpire || expireTime === 0 || isNaN(expireTime)) return "";

		const now = Date.now();
		const tenDays = 10 * 24 * 60 * 60 * 1000;
		const diff = expireTime - now;

		if (diff <= 0) return "table-element-fail";
		if (diff <= tenDays) return "table-element-soon";
		return "table-element-success";
	};

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "id",
				order: "desc",
			});
		}
	};
	const handleView = (id) => {
		setActiveViewId((prev) => (prev === id ? null : id));
	};
	const vehicleColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			width: 150,
			sorter: true,
			fixed: !isRTL ? "left" : undefined,
			render: (name) => (
				<span className={"table-element-name ps-0"}>{name}</span>
			),
		},
		{
			title: trans("plate number"),
			dataIndex: "plateNumber",
			sorter: true,
			width: 150,
			render: (plateNumber) => plateNumber,
		},
		{
			title: trans("license expire"),
			dataIndex: "licenseExpire",
			width: 150,
			render: (licenseExpire) => (
				<span className={getExpireStatusClass(licenseExpire)}>
					{checkExpire(licenseExpire)}
				</span>
			),
		},
		{
			title: trans("IMEI"),
			dataIndex: "imei",
			sorter: true,
			width: 150,
			render: (imei) => imei,
		},
		{
			title: trans("last update"),
			dataIndex: "lastUpdate",
			sorter: true,
			width: 150,
			render: (lastUpdate) => {
				if (!lastUpdate) return "N/A";
				const { formattedDate, formattedTime } = formatDate(lastUpdate);
				return `${formattedDate} ${formattedTime}`;
			},
		},
		{
			title: trans("device type"),
			dataIndex: "deviceType",
			width: 150,
			render: (deviceType) => (
				<Tag color={deviceType === "TRACKER" ? "default" : "blue"}>
					{trans(deviceType)}
				</Tag>
			),
		},
		{
			title: trans("status"),
			dataIndex: "archived",
			width: 150,
			render: (archived) => (
				<Tag color={archived ? "default" : "blue"}>
					{archived ? trans("Archived") : trans("Active")}
				</Tag>
			),
		},
		{
			title: trans("Group Name"),
			dataIndex: "groupName",
			sorter: true,
			width: 150,
			render: (groupName) => groupName || "Ungrouped Vehicle",
		},
		{
			title: trans("linked users"),
			dataIndex: "vehicle_user",
			width: 150,
			render: (_, record) => (
				<div
					className={`d-flex align-items-center ${
						isRTL && "flex-reverse"
					} position-relative`}
				>
					<span className={`${isRTL ? "ms-2" : "me-2"}`}>
						{record?.vehicle_user?.length}
					</span>
					<Button
						disabled={record?.vehicle_user.length === 0}
						type="default"
						onClick={() => handleView(record?.id)}
					>
						{trans("view")}
					</Button>
					{activeViewId === record?.id && (
						<VehicleUsers
							data={record?.vehicle_user}
							setActiveViewId={setActiveViewId}
						/>
					)}
				</div>
			),
		},
		{
			title: trans("Actions"),
			width: 150,
			fixed: !isRTL ? "right" : undefined,
			render: ({ id, name, imei }) => (
				<Actions
					vehicleId={id}
					name={name}
					imei={imei}
					type="link"
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];
	return (
		<>
			<Helmet>
				<title>Vehicles</title>
				<meta name="description" content="Vehicles" />
			</Helmet>
			<SecondHeader
				title={trans("Vehicles")}
				add={create ? trans("Add new vehicle") : null}
				onClick={() => handleShow("addForm")}
				type={"vehicles"}
				secClick={() => setBulkUpload(true)}
			/>

			<VehicleHead setFilter={setFilter} />
			{isLoading || loading ? (
				<>
					<div className="loader-container loader-table">
						<Loader />
					</div>
				</>
			) : (
				<>
					<div className="bg-white-rounded-top table-parent">
						<AntdTable
							columns={vehicleColumns}
							dataSource={
								vehicleArchived === "All vehicles"
									? vehiclesData?.vehicles
									: vehiclesData?.vehicles.filter((j) =>
											vehicleArchived === "Archived"
												? j.archived === true
												: j.archived === false,
										) || []
							}
							loading={isLoading || loading}
							pageSize={limit}
							totalItems={vehiclesData?.totalCount}
							currentPage={currentPage}
							onPageChange={(page) => setCurrentPage(page)}
							onLimitChange={(newLimit) => {
								setLimit(newLimit);
								setCurrentPage(1);
							}}
							onTableChange={handleTableChange}
						/>
					</div>
				</>
			)}
			<Link />

			<VehicleForm onSuccess={handleSuccess} onEdit={handleEdit} />
			<VehicleBulkUpload
				bulkUpload={bulkUpload}
				setBulkUpload={setBulkUpload}
			/>
		</>
	);
}
